module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 382
 ** module chunks = 0
 **/